import script from "./ImageExtra.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageExtra.vue?vue&type=script&setup=true&lang=js"

import "./ImageExtra.vue?vue&type=style&index=0&id=5763b4e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5763b4e4"]])

export default __exports__